import React, { useEffect, useState } from "react";
import "../App.css";
import { ChevronDown } from "lucide-react";

import {
  ColourPalette,
  getIsMobile,
  getIsTablet,
  getMobileDownloadButtonValues,
  getScreenSize,
  getSectionHeight,
  getSectionMargin,
} from "../globalConstants";
import { downloadButtons } from "../globalConstants";
import { Rating, Box } from "@mui/material";
import CountUp from "react-countup";
import { Slide } from "@mui/material";
import { leadSection } from "./leadSection";
import { numbersSection } from "./homeHelper";

const Home = () => {
  const [showChevron, setShowChevron] = useState(true);

  //alert(JSON.stringify(getScreenSize()))
  // Hide chevron on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowChevron(false);
      } else {
        setShowChevron(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle chevron click - scroll to next section
  const handleChevronClick = () => {
    setShowChevron(false);
    // Scroll to the next section (adjust the value based on your section height)
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div className="home-container" style={{
      display: "flex",
      height: "auto",
      alignItems: "center",
      justifyContent: "flex-start",
      width: "100%",
      position: "relative",
      flexDirection: "column",
      overflow: "hidden",
    }}>
      {leadSection()}
      {/* {numbersSection()} */}
      {/* Down Chevron with Fading Background */}
      {/* {getIsMobile() ? null : <div
        style={{
          position: "absolute",
          bottom: 0,
          left: "42.5%",

          width: "15%",
          height: "15%",
          background: "radial-gradient(ellipse 60% 100% at center bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 60%, rgba(255,255,255,0) 90%)",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          paddingBottom: "20px",
          opacity: showChevron ? 1 : 0,
          visibility: showChevron ? "visible" : "hidden",
          transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
          pointerEvents: showChevron ? "auto" : "none",
          zIndex: 10
        }}
      >
        <button
          onClick={handleChevronClick}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "10px",
            borderRadius: "50%",
            backgroundColor: "rgba(18, 64, 28, 1)",
            backdropFilter: "blur(10px)",
            transition: "all 0.2s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          onMouseEnter={(e) => {
            const button = e.currentTarget as HTMLElement;
            button.style.backgroundColor = "rgba(23, 202, 62, 1)";
            button.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            const button = e.currentTarget as HTMLElement;
            button.style.backgroundColor = "rgba(18, 64, 28, 1)";
            button.style.transform = "translateY(0)";
          }}
        >
          <ChevronDown
            size={40}
            color="white"

            style={{
              animation: "bounce 2s infinite",
              backgroundColor: "transparent",
            }}
          />
        </button>
      </div>} */}

    </div >
  );
};

export default Home;